import { rem } from 'polished';
import styled from 'styled-components';

export const StyledHeadingWrapper = styled.div`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    margin-bottom: ${rem('16px')};
  }
`;
